import Application from "../Application";
import Area, { IArea } from "./Area";
import { IRouter } from "../runtime/Router";
import ShowPaymentConfirmationInteractor from "../interactor/payment/ShowPaymentConfirmationInteractor";
import PaymentConfirmationPage from "../ui/pages/payment/PaymentConfirmationPage";
import PaymentInstructionPage from "../ui/pages/payment/PaymentInstructionPage";
import ShowPaymentInstructionInteractor from "../interactor/payment/ShowPaymentInstructionInteractor";

export default class PaymentArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes(
      {
        path: "/payment-confirmation/:shareCode",
        page: this.createPage({
          Page: PaymentConfirmationPage,
          action: this.showPaymentConfirmationPage.bind(this)
        }),
        options: {}
      },
      {
        path: "/payment-instruction/:token",
        page: this.createPage({
          Page: PaymentInstructionPage,
          action: this.showPaymentInstructionPage.bind(this)
        }),
        options: {}
      }
    );
  }

  public showPaymentConfirmationPage(params: any) {
    return this.application.container
      .resolve<ShowPaymentConfirmationInteractor>("showPaymentConfirmation")
      .execute(params.shareCode);
  }

  public showPaymentInstructionPage(params: any) {
    return this.application.container
      .resolve<ShowPaymentInstructionInteractor>("showPaymentInstruction")
      .execute(params.token);
  }
}
